/**
 * Usage:
 *
 * data-sw-shapejs-viewer=<creatorId>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-shapejs-printability-checks]').each(function() {
    var $el = $(this);

    require([
      'js/lib/models/ModelManager',
      'js/lib/views/ShapeJS/ShapeJsPrintabilityChecks'
    ], function(ModelManager, ShapeJsPrintabilityChecks) {
      var creatorId = $el.data('swShapejsPrintabilityChecks');
      var shapeJsModel = ModelManager.getShapeJs(creatorId);

      new ShapeJsPrintabilityChecks({
        el: $el,
        model: shapeJsModel
      });

    });

  });

};
